import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const MIN_ALLOWED_HEIGHT = 560;
const DEFAULT_MESSAGE = 'Please rotate your device to continue editing your project.';

class OrientationMessage extends Component {
  state = {
    open: false
  };

  componentDidMount() {
    window.addEventListener(
      'orientationchange',
      this.onOrientationChange
    );

    this.onOrientationChange();
  }

  componentWillUnmount() {
    window.removeEventListener(
      'orientationchange',
      this.onOrientationChange,
      false
    );
  }

  onOrientationChange = () => {
    document.activeElement.blur();

    setTimeout(() => {
      if (typeof window === 'undefined') return;
      
      const { innerWidth: width, innerHeight: height } = window;

      const isLandscape = width > height;
      const isTooSmall = height < MIN_ALLOWED_HEIGHT;
      const isTouchDevice = 'ontouchstart' in window;

      const open = [isLandscape, isTooSmall, isTouchDevice].every(Boolean);

      this.setState({ open });
    }, 250);
  };

  render() {
    const { open } = this.state;
    const { message } = this.props;

    return (
      <div className={classNames('orientation-message', { 'd-flex': open })}>
        <p>{message || DEFAULT_MESSAGE}</p>
      </div>
    );
  }
}

OrientationMessage.propTypes = {
  message: PropTypes.string
};

OrientationMessage.defaultProps = {
  message: null
};

export default OrientationMessage;
